// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { IconWrapper } from "@stoneage/MobiusOverrides/Icon";
import { fontConfig } from "@stoneage/XDL/constants";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color, styledScrollbar } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            list: css`
                width: 100%;
                transform: translate(0, -4px);
                border: 1px solid ${color("secondary")};
                ${styledScrollbar(8)}
            `,
            noOptions: css`
                color: ${getColor("text.disabled")};
            `,
            option: css`
                font-size: ${fontConfig.small.size}px;
                line-height: ${fontConfig.small.lineHeight};
                font-weight: ${fontConfig.weight.regular};
                padding: 8px;
                &:hover,
                &:focus {
                    background: ${getColor("primary")};
                    color: ${getColor("common.white")};
                }
                background: ${({ selected, focused, theme }: any) =>
                    selected || focused ? getColor("primary") : "transparent"};
                color: ${({ focused, selected, theme }: any) =>
                    focused || selected ? getColor("common.white") : getColor("common.backgroundContrast")};
                &[disabled],
                &[disabled] ~ .clickable-wrapper ${IconWrapper} {
                    opacity: 0.33;
                }
            `,
            selectedText: css`
                line-height: ${fontConfig.xSmall.lineHeight};
            `,
        },
        iconProps: { src: "ChevronDown" },
        mergeCss: true,
    },
} as xBaseTheme["dynamicDropdown"];
